const CONTEXT = '[Traceability Store]';

export class GetTraceabilityRecentEvents {
  static readonly type = `${CONTEXT} Get Recent Events`;
  constructor(
    public page?: number,
    public limit?: number,
  ) {}
}

export class GetTraceabilityStats {
  static readonly type = `${CONTEXT} Get Stats`;
}

export class GetTraceabilityHistory {
  static readonly type = `${CONTEXT} Get History`;
  constructor(public qrProductDataId: number) {}
}

export class VerifyTraceabilityRecord {
  static readonly type = `${CONTEXT} Verify Record`;
  constructor(public qrProductDataId: number) {}
}

export class ResetTraceabilityState {
  static readonly type = `${CONTEXT} Reset State`;
}

export class ClearTraceabilityHistory {
  static readonly type = `${CONTEXT} Clear History`;
}
